import { RootState } from '@/store';
import { addCurrentThemeClassToEle } from '@/utils';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import LightGrayCross from "@/assets/icons/lightGrayCross.png";
import "./style.css"
import { themes } from '@/constants/colors_v2';

function EmptyModal(props: any) {
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);
    // console.log(props)
    return (
        <Modal
            show={props.show}
            onHide={() => props.handleClose('close')} centered>
            <div className={`p-[20px] ${addCurrentThemeClassToEle(currentTheme, 'emptyModalIndex')}`}>

                <Modal.Header className='p-0 border-0 mb-[10px]'>


                    {currentTheme === themes.dark ? (
                        <div className='darkThemetopCloseButtonHelperModelCon'>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {props.popupInfo.title}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='text-[14px]'
                                aria-label="Close">
                                <img src={LightGrayCross} alt='LightGrayCross' className='w-[14px]' />
                            </button>
                        </div>
                    ) : (
                        <>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {props.popupInfo.title}
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose('close')}
                                type="button"
                                className='btn-close topCloseButtonHelper'
                                aria-label="Close">
                            </button>

                        </>
                    )}

                    {/* <Modal.Title className='text-[16px] font-bold'>
                        {props.popupInfo.title}
                    </Modal.Title>
                    <button
                        onClick={() => props.handleClose('close')}
                        type="button"
                        className="btn-close text-[14px]" aria-label="Close"></button> */}

                </Modal.Header>

                <Modal.Body className='p-0'>
                    <div dangerouslySetInnerHTML={{ __html: props.popupInfo.content }} />
                </Modal.Body>

            </div>
        </Modal>
    );
}

export default EmptyModal;